import { Component } from '@angular/core';
import { AuthService } from './shared/service/auth/auth.service';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { ParameterService } from './shared/service/params/param';
  import Swal from 'sweetalert2';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'X-Project';


  logo: any;
  commune: any;

  constructor(
    private authService: AuthService,
    private messageService: MessageService,
    private router: Router,
    private paramService: ParameterService,

  ) { 
    this.getLogoNomCommune();
  }

  configMairie: any = {};

  getLogoNomCommune() {

    this.paramService.getParamatrageCommune().subscribe(
      (response: any) => {
    //    console.log("le logo du webservice", response);
        this.configMairie = response.data
        this.logo = this.configMairie?.logo?.value;
        this.commune = this.configMairie?.commune?.value;
        const favicon = document.getElementById('appFavicon') as HTMLLinkElement;
        if (favicon) {
          favicon.href = this.logo;
        }
      },
      (error: any) => {
      //  console.log("une erreur est survenu", error);

      }
    )
  }

  onImageError(event: Event): void {
    const target = event.target as HTMLImageElement;
    target.src = '../../../assets/new-accueil/logo-vrai.png';
  }


}
